import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import OthComponent from './oth.component';
import ContentService from '../../services/content.service';

let OthModule = angular
  .module('Oth', [
    uiRouter
  ])
  .component('oth', OthComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('oth', {
      url: '/oth',
      data: {
        authRequired: true,
        permsRequired: ['oth-bills']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'oth'
        }
      }
    })
  })
  .name;

export default OthModule;



// WEBPACK FOOTER //
// ./src/app/pages/oth/oth.module.js